/*
 * @Author: liuxw@codoon.com
 * @Date: 2021-07-12 16:20:59
 * @Last Modified by:   liuxw@codoon.com
 * @Last Modified time: 2021-07-12 16:20:59
 */

/* 保留2位小数 */
export const keep2Decimal = (num?: number) => {
  if (num) {
    return parseInt(`${num * 100}`) / 100;
  } else {
    return 0;
  }
};

/* 小数点前的部分，每3位1个逗号 */
export const addDividerToNumber = (num: number) => {
  let numStr = `${num}`;
  const numArr = numStr.split(".");
  let leftNumStr = numArr[0];
  const leftNumArr = [];
  for (let index = leftNumStr.length; index > 0; index -= 3) {
    leftNumArr.push(leftNumStr.slice(Math.max(index - 3, 0), index));
  }
  leftNumArr.reverse();
  leftNumStr = leftNumArr.join(",");
  if (numArr[1]) {
    return `${leftNumStr}.${numArr[1]}`;
  } else {
    return leftNumStr;
  }
};
